export default __webpack_public_path__ + "static/validationtemplate-27935761d3fad99c5f70e0329736dfdd.png";